import { useSuspenseQuery } from "@tanstack/react-query";
import { pathPickSearchProductsQueryApi } from "@/features/pathpick/features/search-products/api/query";
import { PathPickPopularBrandsRequestParams } from "@/features/pathpick/features/search-products/types/request-params";
import { PathPickPopularBrandsResponse } from "@/features/pathpick/features/search-products/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

const useGetPathPickPopularBrands = (
  params?: PathPickPopularBrandsRequestParams
) => {
  const { companyId } = useCompanyIdentity();

  const { data: pathPickPopularBrands } = useSuspenseQuery({
    queryKey: ["pathpick", "popular-brands", companyId, params],
    queryFn: companyId
      ? () =>
          pathPickSearchProductsQueryApi.getPathPickPopularBrands(
            companyId,
            params
          )
      : undefined,
    select: (data) => toCamelKeyObject(data) as PathPickPopularBrandsResponse,
  });

  return { pathPickPopularBrands };
};

export default useGetPathPickPopularBrands;
